import { AccountType } from 'further-types/investor';
import { ApiResponses } from 'lib/trpcClient';
import { useMemo } from 'react';

type Props = {
  investorData?: ApiResponses['investor']['getInvestor'];
};

export const useSelectedInvestorWarnings = ({ investorData }: Props) => {
  const isIndividual = investorData?.accountType === AccountType.Individual;

  const errors: { missingPrimaryTaxId?: string; missingTaxResidency?: string } =
    useMemo(() => {
      return {
        missingPrimaryTaxId:
          isIndividual && investorData && !investorData.primaryTaxId
            ? 'tax ID (e.g. NINO)'
            : undefined,
        missingTaxResidency:
          investorData && !investorData.taxResidencies?.length
            ? 'tax residency'
            : undefined,
      };
    }, [investorData, isIndividual]);

  return {
    hasErrors: Object.values(errors).some((error) => error),
    errors,
  };
};
